import { cuartosFriosTypes } from "@/mocks/serviceCuartosFriosData";

export default function CuartosFriosTypes() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="reveal text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
            Tipos de soluciones
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Soluciones adaptadas a cada necesidad
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Dos líneas de soluciones de refrigeración según la temperatura requerida y el tipo de
            producto a conservar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {cuartosFriosTypes.map((type, i) => (
            <div
              key={type.title}
              className="reveal rounded-xl overflow-hidden border border-background-200 bg-background-50 group"
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="relative h-[240px] md:h-[280px] overflow-hidden">
                <img
                  src={type.image}
                  alt={`${type.title} en cuarto frío industrial`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                  <div className="w-12 h-12 rounded-lg bg-[#0087a4] flex items-center justify-center shrink-0">
                    <i className={`${type.icon} text-white text-2xl`} />
                  </div>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 leading-tight">
                    {type.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 md:p-8">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {type.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}